import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/catalogos/tipo-de-asignacion-de-plaza/';

/**
 * GET TipoAsignaciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposAsignacion = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET TipoAsignacion
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoAsignacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST TipoAsignacion
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoAsignacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH TipoAsignacion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoAsignacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE TipoAsignacion
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTipoAsignacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
